<template>
  <button
    class="btn"
    :type="type"
    @click="reemitClickEvent"
    @mouseenter="$store.dispatch($CHANGE_CURSOR_STATE, 'pointer')"
    @mouseleave="$store.dispatch($CHANGE_CURSOR_STATE, 'default')"
  >
    <span tabindex="-1" class="btn__content">
      <slot />
    </span>
  </button>
</template>

<script>
export default {
  name: 'Btn',
  props: {
    type: String
  },
  methods: {
    reemitClickEvent (event) {
      this.$emit('click', event)
    }
  }
}
</script>

<style scoped lang="sass">
  @tailwind utilities

  .btn
    cursor: none
    outline: none
    &:focus > .btn__content
      box-shadow: 0 4px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.08), 0 0 1px 2px #ff0000
    &:focus, & > *:focus
      outline: none
    &__content
      @apply relative inline-block
      height: inherit
      width: inherit

  .btn:focus,
  .btn__content:focus
    outline: none
</style>
